/**
 * @generated SignedSource<<ccba00cf571c5fc958b7d3b1e170b1b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type superSplashLiveLiveWidget$data = {
  readonly label: string | null | undefined;
  readonly relatedArticles: ReadonlyArray<{
    readonly entityUuid: string;
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "superSplashLiveLiveWidget";
};
export type superSplashLiveLiveWidget$key = {
  readonly " $data"?: superSplashLiveLiveWidget$data;
  readonly " $fragmentSpreads": FragmentRefs<"superSplashLiveLiveWidget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "superSplashLiveLiveWidget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "relatedArticles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityUuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlAlias",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "contentItemRenderContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LiveWidget",
  "abstractKey": null
};

(node as any).hash = "344e3444ddaa482b8b91cb42445a46f5";

export default node;
